import { render, staticRenderFns } from "./payments-editor-roadmap.vue?vue&type=template&id=481f5ad6"
import script from "./payments-editor-roadmap.vue?vue&type=script&lang=js"
export * from "./payments-editor-roadmap.vue?vue&type=script&lang=js"
import style0 from "./payments-editor-roadmap.vue?vue&type=style&index=0&id=481f5ad6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports